export default __webpack_public_path__ + "static/media/345.37b347cd.png";